import React from 'react'
import { NewButton } from 'newComponents'
import classNames from 'classnames'
import './styles.scss'

const PrimarySecondaryButtons = ({ primaryText, primaryLink, secondaryText, secondaryLink, className }) => {

  const hasPrimary = primaryText && primaryLink
  const hasSecondary = secondaryText && secondaryLink

  return (
    <section className={`primary-secondary-buttons ${className || ''}`}>
      {hasPrimary && (
        <NewButton to={primaryLink} className="primary-secondary-buttons-primary new-button" chevron>
          {primaryText}
        </NewButton>
      )}
      {hasSecondary && (
        <NewButton
          to={secondaryLink}
          className={classNames('primary-secondary-buttons-secondary', { 'only-secondary': !hasPrimary })}
          chevron
        >
          {secondaryText}
        </NewButton>
      )}
    </section>
  )
}

export default PrimarySecondaryButtons
